module.exports = __webpack_public_path__ + "img/13_attach_terminals.a9363bc1.jpg";